import { STATE_ABBR_TO_NAME } from '@/utils/consts/city/city-index.const';
import { City } from '@/types/city.type';

export async function getCitiesByUf(uf: string): Promise<City[] | null> {
  try {
    const formatedUf = uf.toUpperCase();

    if (!STATE_ABBR_TO_NAME[formatedUf]) {
      return null;
    }

    const citiesModule = await import(`@/utils/consts/city/city-by-state/${formatedUf.toLowerCase()}`);

    const cities = citiesModule[`ALL_CITIES_${formatedUf}`];

    if (!cities) {
      return null;
    }

    return cities;
  } catch {
    return null;
  }
}
